import React, {Component} from 'react'

class ImageQualityProgressBar extends Component {
  constructor(){
    super();
    this.state = {posterDetails: ''}
    this.handlePosterDetails = this.handlePosterDetails.bind(this);
  }

  handlePosterDetails(percentageQuality){
    switch(true) {
      case (percentageQuality > 80):
        var progressColor = 'success';
        break;
      case (percentageQuality > 50 && percentageQuality <= 80):
        var progressColor = 'warning';
        break;
      case (percentageQuality <= 50):
        var progressColor = 'danger';
        break;
    }

    var obj = {
        progressColor:  progressColor,
        percentageQuality: percentageQuality
    };

    this.setState({posterDetails: obj})
  }

  render() {
    var img = new Image();
    var that = this;
    img.onload = function(){
      if(img.src !== null){
        var horizontalMeasure = Math.min(img.naturalWidth/refWidth, 1);
        var verticalMeasure = Math.min(img.naturalHeight/refHeight, 1);
        var percentageQuality = Math.round(Math.min(horizontalMeasure, verticalMeasure) * 100);

        that.handlePosterDetails(percentageQuality);
      }
    }
    img.src = this.props.imageUrl;
    var refWidth = this.props.refWidth;
    var refHeight = this.props.refHeight;

    if(this.state.posterDetails){
      return (
        <React.Fragment>
          <div className="row">
            <div className="col">
            <div>Image quality</div>
            <small className="pull-left">Bad</small>< small style={{marginLeft: "75%"}}>Poor</small><small className="pull-right">Good</small>
              <div className="progress progress-lg">
                <div className={"progress-bar bg-" + this.state.posterDetails.progressColor} value={this.state.posterDetails.percentageQuality} style={{width: this.state.posterDetails.percentageQuality + '%' }} role="progressbar"></div>
              </div>
            </div>
          </div>
        </React.Fragment>
      )
    }else{
      return(<div></div>)
    }

  }
}

export default (ImageQualityProgressBar)
